/**
 * Build a `tel://` href for a phone number, resolving the country code by
 * the contact's country name against the app's country list. Falls back to
 * "1" (US/Canada) when the country is missing or not in the list, so click-
 * to-call links never throw on records with incomplete location data.
 *
 * Returns undefined when there's no phone number — bind the result to
 * `:href` and the anchor becomes inert.
 */
export function phoneHref(phoneNumber, countryName, countryCodes) {
  if (!phoneNumber) return undefined;
  if (!countryName) {
    return `tel://1${phoneNumber}`;
  }
  const countryCode =
    countryCodes?.find((option) => option.name === countryName)?.countryCode ??
    "1";
  return `tel://${countryCode}${phoneNumber}`;
}
